import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Spinner } from '../../../../common/components/loaders/spinner/Spinner'
import { useGame } from '../../../../contexts/GameContext'
import { getOldUIRoutes } from '../../../../routes'
import styles from './GameReportFrame.module.css'
// import { useUser } from '../../../../contexts/userContext'
// import { AllowedOption } from '../../../../types/commonTypes'
import { GameReport } from './GameReport'
import { GameReportDataProvider } from '../../../../contexts/GameReportContextProvider'
import classNames from 'classnames'

type GameReportFrameProps = {
  gameId: number | null
}

export const GameReportFrame: React.FC<GameReportFrameProps> = ({ gameId }) => {
  const gameReportUrl = getOldUIRoutes.gameReport(gameId)
  //const { user } = useUser()
  const [reportLoaded, setReportLoaded] = useState(true /*user?.allowedOptions.includes(AllowedOption.UX3_REPORTING)*/)
  const { tasks, people } = useGame()
  const { t } = useTranslation()

  //NOTE Leaving the new/old report related things commented here if we them
  const useNewReport = true //user?.allowedOptions.includes(AllowedOption.UX3_REPORTING)

  const handleReportLoaded = useCallback(() => {
    setReportLoaded(true)
    const msg = { exerciseData: tasks, playerData: people.players }
    const reportFrame: HTMLIFrameElement = document.getElementById('reportFrame') as HTMLIFrameElement
    reportFrame.contentWindow?.postMessage(msg, '*')
  }, [people.players, tasks])

  useEffect(() => {
    try {
      const mapboxLogo = document.getElementsByClassName('mapboxgl-ctrl-bottom-left')[0] as HTMLElement
      const openStreetMap = document.getElementsByClassName('mapboxgl-ctrl-bottom-right')[0] as HTMLElement
      mapboxLogo.style.display = 'none'
      openStreetMap.style.display = 'none'
    } catch (e) {}
    return () => {
      try {
        const mapboxLogo = document.getElementsByClassName('mapboxgl-ctrl-bottom-left')[0] as HTMLElement
        const openStreetMap = document.getElementsByClassName('mapboxgl-ctrl-bottom-right')[0] as HTMLElement
        mapboxLogo.style.display = 'initial'
        openStreetMap.style.display = 'initial'
      } catch (e) {}
    }
  })

  return (
    <div className={classNames(styles.mainContainer, !useNewReport && styles.mainContainerHeight)}>
      <div className={styles.reportsView}>
        {!reportLoaded && (
          <div className={styles.spinnerContainer}>
            {gameId ? (
              <Spinner remSize={4} />
            ) : (
              <h2 className={styles.notAvailableInfo}>
                {t(
                  'game_editor.report.create_game_first',
                  'To see the report, make sure the game is set up in the settings',
                )}
              </h2>
            )}
          </div>
        )}
        {gameId && !useNewReport && (
          <iframe
            id={'reportFrame'}
            style={reportLoaded ? {} : { display: 'none' }}
            onLoad={handleReportLoaded}
            title='Reports view'
            src={gameReportUrl}
            className={styles.reportContainer}
          />
        )}
        {gameId && useNewReport && (
          <GameReportDataProvider gameId={gameId}>
            <GameReport gameId={gameId} />
          </GameReportDataProvider>
        )}
      </div>
    </div>
  )
}
